"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goalBucketZeroShareCopy = goalBucketZeroShareCopy;
/**
 * A goal's new Forecast bucket that starts at 0% (BEN-141 FP-046).
 *
 * "Create new" on a goal makes a bucket that only takes unallocated share (#854),
 * so on the usual full split it is created at 0%. The goal card then named the
 * bucket, Forecast said "You've allocated 100%… Great job!", and the goal got $0 a
 * paycheck with nothing saying so. Said where it happens, right after the save;
 * the goal sheet has no share field, so the share is set on Forecast.
 */
function goalBucketZeroShareCopy(goalName) {
    return {
        title: `${goalName}'s bucket starts at 0%`,
        message: `Your split is already fully allocated, so "${goalName}" gets nothing from each paycheck yet. Give it a share on Forecast.`,
        confirmLabel: "Open Forecast",
        cancelLabel: "Later",
    };
}
//# sourceMappingURL=goalBucketCopy.js.map